


import { EntityState, EntityAdapter, createEntityAdapter, Update } from '@ngrx/entity';
import { createReducer, on  } from '@ngrx/store';
import { get } from 'lodash';

import { ScreenState } from '@core/store';


import * as fromMaster from './master-perfil-acesso.actions';
import * as fromStore from '@app/core/store';
import * as featureAdapter from '@core/store/feature-adapter';

export interface State extends EntityState<ScreenState<any>> { }
export const adapter: EntityAdapter<ScreenState<any>> = createEntityAdapter<ScreenState<any>>({});

export const initialState: State = adapter.getInitialState();

const _reducer = createReducer(initialState,
    on(fromMaster.initAction, (state, payload) =>
      adapter.addOne(payload, state)
    ),
    on(fromMaster.destroyAction, (state, payload) =>
      adapter.removeOne(payload, state)
    ),
    on(fromMaster.initStateAction, (state, payload) =>
      adapter.addOne({ ...payload, loading: true}, state)
    ),
    on(fromMaster.initValueSuccessAction, (state, payload) =>
      featureAdapter.initValue<any>(state, payload, adapter)
    ),
    on (fromMaster.initValueFailAction,(state, payload) =>
      featureAdapter.cancelLoading<any>(state,payload,adapter)
    ),
    on(fromStore.validateScreenAction, (state, payload) =>
    adapter.updateOne({ id: payload.id, changes: { validate: true } }, state)
    ),
    on(fromMaster.updateDataAction, (state, payload) =>
      adapter.updateOne(
        {
          id: payload.id,
          changes: {
            value: { ...payload.data },
            isValid: payload.isValid,
            validate: false
          }
        },
        state
      )
    ),

                                    
on(fromMaster.fetchFieldPossibleValuesAction, (state, payload) =>
  adapter.updateOne({ ...payload, loading: true }, state)
),
on(fromMaster.fetchFieldPossibleValuesSuccessAction, (state, payload) =>
  featureAdapter.updateFieldPossibleValues(
      state,
      payload.id,
      payload,
      adapter)
),
on(fromMaster.fetchFieldPossibleValuesFailAction, (state, payload) =>
    featureAdapter.cancelLoading(state, payload, adapter)
),


        );
export function reducer(state, action) {
  return _reducer(state, action);
}


